import React, { useContext, useEffect, useRef, useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { fetch } from '../../../utility/helpers/Axios/fetch'
import { getUserData } from '../../../utility/Utils'
import { ModalContext } from '../contactform/ModalContext'

export const AddUserModal = (props) => {

    const { domain } = props
    const { statusModal, setStatusModal } = useContext(ModalContext)
    const [form, setForm] = useState({})
    const [users, setUsers] = useState([])
    const modal = useRef(null)

    useEffect(() => {
        setForm({
            email: getUserData().email
        })
    }, [])

    const addUserToDomain = async (e) => {
        e.preventDefault()
        console.log(domain, users)
        await fetch("AddUserToDomain", null, { contextData: { ...domain }, template: "addUserToDomain", to: users.map((us) => us.value), subject: `Invitacion a Dominio ${domain.domainName}` }, 'POST')
        setStatusModal(false)
        setUsers([])
    }

    // const onChange = (e) => {
    //     console.log({
    //         ...form,
    //         [e.target.name]: e.target.value
    //     })
    //     setForm({
    //         ...form,
    //         [e.target.name]: e.target.value
    //     })
    // }    

    // const onSubmit = async (e) => {
    //     e.preventDefault()
    //     console.log(e)
    //     await fetch('KlinnicUser', null, {
    //         // fullName:,
    //         // email:,
    //         // password:,
    //     }, 'POST')
    // }
    return (
        <div className='vertically-centered-modal' >
            <Modal id='modalUserAdd' scrollable isOpen={statusModal} toggle={() => setStatusModal(!statusModal)} className='modal-dialog-centered modal-lg' >
                <form onSubmit={(e) => addUserToDomain(e)}>
                    <ModalHeader toggle={() => setStatusModal(!statusModal)}>Invitar usuarios</ModalHeader>
                    <ModalBody >
                        <div>
                            <CreatableSelect
                                option={users}
                                id='usersToAdd'
                                menuPortalTarget={document.body}
                                styles={{

                                    menuPortal: (provided, state) => ({
                                        ...provided,
                                        zIndex: 9999
                                    })
                                }}
                                onChange={(e) => { setUsers(e) }}
                                className="table-select form-control-sm"
                                isClearable isMulti={true}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="submit" className='btn btn-primary'>Enviar</button>
                    </ModalFooter>
                </form>
            </Modal>
        </div>
    )
}
